module.exports = __webpack_public_path__ + "img/riwayat-active.31ed605.png";